import { Store } from 'vuex'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.FieldCreated',
    callback: (field: KwixeoCustomFields.Field): void => {
      store.dispatch('customFields/setCustomField', field)
    }
  },
  {
    name: '.FieldUpdated',
    callback: (field: KwixeoCustomFields.Field): void => {
      store.dispatch('customFields/setCustomField', field)
    }
  },
  {
    name: '.FieldDeleted',
    callback: (field: KwixeoCustomFields.Field): void => {
      store.dispatch('customFields/deleteCustomField', field)
    }
  }
])
